import { useState, useEffect } from 'react';
import api from '../services/api';

export interface Empresa {
  id: number;
  nome: string;
  cnpj: string;
  email?: string;
  telefone?: string;
  cep?: string;
  logradouro?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  estado?: string;
  logoFolioClaro?: string;
  logoFolioEscuro?: string;
  logoEmpresaClaro?: string;
  logoEmpresaEscuro?: string;
  logo?: string;
  logoSecundario?: string;
  logoConfig?: string;
  corPrimaria?: string;
  corSecundaria?: string;
  corAccent?: string;
  corBackground?: string;
  suporteInicio?: string;
  suporteFim?: string;
  notificarFatura?: boolean;
  notificarRelatorio?: boolean;
  notificarDocumento?: boolean;
  notificarTicket?: boolean;
}

export function useEmpresaConfig() {
  const [empresa, setEmpresa] = useState<Empresa | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  const loadEmpresa = async () => {
    try {
      const response = await api.get('/admin/empresa');
      setEmpresa(response.data);
    } catch (error) {
      console.error('Erro ao carregar configurações:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const saveEmpresa = async (data: Empresa) => {
    setIsSaving(true);
    setMessage(null);
    try {
      await api.put('/admin/empresa', data);
      setMessage({ type: 'success', text: 'Configurações salvas com sucesso!' });
      window.dispatchEvent(new Event('empresa-config-updated'));
      await loadEmpresa();
      return true;
    } catch (error) {
      console.error('Erro ao salvar:', error);
      setMessage({ type: 'error', text: 'Erro ao salvar configurações' });
      return false;
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    loadEmpresa();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { empresa, setEmpresa, isLoading, isSaving, message, setMessage, saveEmpresa, loadEmpresa };
}
